import { useParams } from 'react-router-dom';
import VehicleDetailPage from './VehicleDetailPage';

export default function ReservationPage() {
  const { vehicleId } = useParams<{ vehicleId: string }>();
  return <VehicleDetailPage />;
}
